"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VestingReleasableButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const exchange_1 = require("@framework/exchange");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const releasable_json_1 = __importDefault(require("@framework/abis/json/Vesting/releasable.json"));
const VestingReleasableButton = (props) => {
    const { balance, className, disabled, variant } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { execute: metaReleasable } = (0, react_hooks_eth_1.useMetamaskValue)(async (balance) => {
        if (balance.token?.template?.contract?.contractType === types_1.TokenType.ERC20) {
            return writeContractAsync({
                address: balance.account,
                abi: releasable_json_1.default,
                functionName: "releasable",
                args: [balance.token.template.contract.address],
            });
        }
        else if (balance.token?.template?.contract?.contractType === types_1.TokenType.NATIVE) {
            return writeContractAsync({
                address: balance.account,
                abi: releasable_json_1.default,
                functionName: "releasable",
                args: [],
            });
        }
        else {
            throw new Error("unsupported token type");
        }
    }, { success: false });
    const handleClick = async () => {
        const amount = (await metaReleasable(balance));
        if (amount) {
            alert(`Releasable: ${(0, exchange_1.formatEther)(amount.toString(), balance.token?.template?.contract?.decimals, balance.token?.template?.contract?.symbol)}`);
        }
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleClick, icon: icons_material_1.Visibility, message: "form.tips.releasable", className: className, dataTestId: "VestingReleasableButton", disabled: disabled, variant: variant }));
};
exports.VestingReleasableButton = VestingReleasableButton;
//# sourceMappingURL=index.js.map